<div class="title">
    {{"changeColor.Color selector"|translate}}
</div>

<color-photoshop [color]="defualtColor" (onChangeComplete)="handleChangeComplete($event.color.hex)"
    direction="vertical"></color-photoshop>

<div class="footer">


    <div class="preview_color">
        HEX
        <div class="color">
            <span class="box" [ngStyle]="{'background-color': defualtColor}"></span>
            <span class="code"><input [(ngModel)]="defualtColor" (ngModelChange)="OnWriteColor($event)"
                    maxlength="7"></span>
        </div>
    </div>
    <button mat-button>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path id="ic_eyedropper"
                d="M19.912,2.587a2.25,2.25,0,0,0-3.182,0L13.7,5.613,11.571,3.479,9.184,5.866l1.871,1.871-8.3,8.3a.631.631,0,0,0-.181.518h0v2.813a.563.563,0,0,0,.563.563H6.016a.631.631,0,0,0,.447-.185l8.3-8.3,1.871,1.871,2.386-2.386L16.886,8.795l3.026-3.026a2.25,2.25,0,0,0,0-3.182ZM5.613,18.8H3.7V16.885L11.95,8.631l1.918,1.918Z"
                transform="translate(-2.571 -1.928)" />
        </svg>
    </button>
</div>